/* Catalogue frame.
   The flipbook is only fetched when a customer asks for it, and it is thrown
   away on close so a heavy third party page never keeps running behind the
   scenes. Falls back to a new tab if <dialog> is not supported. */
(function () {
  function init(modal) {
    if (!modal || modal.dataset.katalogReady === 'true') return;
    modal.dataset.katalogReady = 'true';

    var frame = modal.querySelector('[data-katalog-frame]');
    var heading = modal.querySelector('[data-katalog-heading]');
    var newTab = modal.querySelector('[data-katalog-newtab]');
    var closeBtn = modal.querySelector('[data-katalog-close]');
    var opener = null;

    function open(url, title, trigger) {
      if (!url) return;
      opener = trigger || null;
      if (heading) heading.textContent = title || '';
      if (newTab) newTab.href = url;

      var iframe = document.createElement('iframe');
      iframe.src = url;
      iframe.title = title || 'Katalog';
      iframe.loading = 'lazy';
      iframe.allowFullscreen = true;
      iframe.setAttribute('allow', 'fullscreen');
      frame.innerHTML = '';
      frame.appendChild(iframe);

      modal.showModal();
      document.documentElement.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      frame.innerHTML = '';
      document.documentElement.style.overflow = '';
      if (opener && typeof opener.focus === 'function') opener.focus();
      opener = null;
    }

    modal.addEventListener('close', close);
    if (closeBtn) {
      closeBtn.addEventListener('click', function () { modal.close(); });
    }

    // clicking the backdrop closes it
    modal.addEventListener('click', function (event) {
      if (event.target === modal) modal.close();
    });

    modal.katalogOpen = open;
  }

  function initSlider(slider) {
    if (!slider || slider.dataset.katalogSliderReady === 'true') return;
    slider.dataset.katalogSliderReady = 'true';

    var track = slider.querySelector('[data-katalog-track]');
    var prev = slider.querySelector('[data-katalog-prev]');
    var next = slider.querySelector('[data-katalog-next]');
    if (!track) return;

    function step() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      var overflow = track.scrollWidth - track.clientWidth > 4;
      var atStart = track.scrollLeft <= 4;
      var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      if (prev) prev.hidden = !overflow || atStart;
      if (next) next.hidden = !overflow || atEnd;
    }

    if (prev) prev.addEventListener('click', function () { track.scrollLeft -= step(); });
    if (next) next.addEventListener('click', function () { track.scrollLeft += step(); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    // the covers change the track width as they load
    window.setTimeout(update, 400);
  }

  /* A page image can sit in Files, in the theme, or not exist at all. The
     image walks down the list rather than giving up on the first miss. */
  function initFallbacks(scope) {
    var imgs = (scope || document).querySelectorAll('[data-katalog-fallbacks]');
    for (var i = 0; i < imgs.length; i++) {
      (function (img) {
        if (img.dataset.katalogFallbackReady === 'true') return;
        img.dataset.katalogFallbackReady = 'true';
        var queue = (img.getAttribute('data-katalog-fallbacks') || '')
          .split('|')
          .filter(function (url) { return url && url !== img.getAttribute('src'); });

        img.addEventListener('error', function () {
          var next = queue.shift();
          if (next) {
            img.src = next;
          } else {
            img.remove();
          }
        });
      })(imgs[i]);
    }
  }

  function bind(scope) {
    var root = scope || document;
    initFallbacks(root);
    var sliders = root.querySelectorAll('[data-katalog-slider]');
    for (var s = 0; s < sliders.length; s++) initSlider(sliders[s]);

    var modals = root.querySelectorAll('[data-katalog-modal]');
    for (var i = 0; i < modals.length; i++) init(modals[i]);

    var triggers = root.querySelectorAll('[data-katalog-open]');
    for (var j = 0; j < triggers.length; j++) {
      (function (trigger) {
        if (trigger.dataset.katalogBound === 'true') return;
        trigger.dataset.katalogBound = 'true';
        trigger.addEventListener('click', function (event) {
          var section = trigger.closest('.shopify-section, body');
          var modal = section ? section.querySelector('[data-katalog-modal]') : null;
          if (!modal) modal = document.querySelector('[data-katalog-modal]');
          var url = trigger.getAttribute('data-katalog-url');

          if (!modal || typeof modal.showModal !== 'function') {
            window.open(url, '_blank', 'noopener');
            return;
          }
          event.preventDefault();
          modal.katalogOpen(url, trigger.getAttribute('data-katalog-title'), trigger);
        });
      })(triggers[j]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(); });
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', function (event) { bind(event.target); });
})();
